import { combineReducers } from 'redux';
import { reducer as FormReducer } from 'redux-form';
import { reducer as toastReducer } from 'react-redux-toastr';

//import testReducer from '../../features/testarea/testReducer';
import AuthReducers from '../../features/auth/AuthReducers';
import asyncReducer from '../../features/async/asyncReducer';
import PaymentReducers from '../../features/payments/PaymentReducers';
import ModalReducer from '../../features/modals/modalReducer';
import CardReducers from '../../features/savedCards/CardReducers';
import Options from '../../features/SearchableDropDowns/DropDownReducers';
import OTPreducers from '../../features/OTP/OTPreducers';
import accountReducers from '../../features/bankAccounts/accountReducers';
import LimitReducers from '../../features/transactionLimit/LimitReducers';
import userReducers from '../../features/UserProfile/userReducers';
import statementReducers from '../../features/walletStatement/statementReducers';
import KYCReducers from '../../features/KYC/KYCReducers';
import SideBarReducers from '../../features/nav/SideBar/SideBarReducers';
import TwoFAReducers from '../../features/twoFA/twoFAreducers';

const rootReducer = combineReducers({
  form: FormReducer,
  //test: testReducer,
  toastr: toastReducer,
  auth: AuthReducers,
  async: asyncReducer,
  payment: PaymentReducers,
  modals: ModalReducer,
  cards: CardReducers,
  options: Options,
  otp: OTPreducers,
  bank: accountReducers,
  limit: LimitReducers,
  profile: userReducers,
  statement: statementReducers,
  kyc: KYCReducers,
  sidebar: SideBarReducers,
  twofa: TwoFAReducers,
})

export default rootReducer;